import React from "react";
import { FiExternalLink } from "react-icons/fi";
import styled from "styled-components";
import homeScreenIcon from "./images/homeScreen.svg";
import { redirectToNewDashboard } from "../components/common";

const Container = styled.div`
  padding-left: 24px;
  background-color: #fff;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ececec;
  padding-top: 35px;
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const Title = styled.span`
  color: #3e3e3e;
  font-size: 32px;
  font-family: Helvetica Neue;
  font-weight: 500;
  letter-spacing: 0.192px;
`;

const Seperator = styled.div`
  margin-top: 15px;
  margin-bottom: 20px;
  width: 40px;
  height: 4px;
  background-color: #24ca7a;
`;

const Text = styled.span`
  color: #777;
  font-family: Helvetica Neue;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.096px;
`;

const Button = styled.div`
  margin-top: 40px;
  width: 383px;
  height: 44px;
  border-radius: 4px;
  background-color: #24ca7a;
  text-align: center;
  padding-block: 10px;
  cursor: pointer;
  display: flex;
  padding-left: 35px
`;

const ButtonText = styled.span`
  color: #fff;
  font-family: Helvetica Neue;
  font-size: 16px;
  font-weight: 700;
  margin-right: 11px;
  letter-spacing: 0.096px;
`;

export const NewBankConnectRedirect = () => {
  return (
    <Container>
      <div style={{paddingTop: "35px"}}>
        <Title>BankConnect dashboard is moving!</Title>
        <Seperator />
        <Text>
          The all new BankConnect dashboard is ready to use.<br />Get statement analysis, usage and reports at your fingertips!
        </Text>
        <Button onClick={redirectToNewDashboard}>
          <ButtonText>
            Take me to the all new dashboard{" "}
          </ButtonText>
          <FiExternalLink size={20} color="#fff" style={{marginTop : "2px"}} />
        </Button>
      </div>
      <img src={homeScreenIcon} style={{}} />
    </Container>
  );
};
